import { EventEmitter, Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { UserDb, User, NewUserFinish, UserPrev } from './user';
import { Utils } from './utils';
import { environment } from '../../environments/environment';
import { PlanesProvider, ProyectQr } from './planes';

@Injectable()
export class AuthProvider {

    authUserCredentials: UserLogin;
    isLoggedIn: boolean = false;
    loginEmitter: EventEmitter<any> = new EventEmitter();
    logoutEmitter: EventEmitter<{finishSignUp: boolean, baned: boolean}> = new EventEmitter();
    redirectUrl: string;
    userLoggend: UserDb;
    userPrev: UserPrev;
    userPrevRegister: NewUserFinish;

    constructor(private afAuth: AngularFireAuth, private _planes: PlanesProvider, private _user: User, private _utils: Utils) {
        this.afAuth.authState.subscribe((user: firebase.User) => {
            if (user) {
                // this.logout();
                this.isLoggedIn = true;
                this._user.find(user.uid).then(udb => {
                    this.userLoggend = udb;
                    this.loginEmitter.emit(this.redirectUrl);
                }).catch(e => {
                    if (this.userPrev) {
                        this._user.removePreviousRegistration(this.userPrev.id).then(_ => {
                            this.userPrev.id = user.uid;
                            console.log('new user', this.userPrev, user, this.userPrevRegister);
                            let saveUser = new UserDb();
                            saveUser.baneado = this.userPrev.baneado;
                            saveUser.codigosQr = [];
                            saveUser.domicilio = this.userPrevRegister.domicilio;
                            saveUser.email = this.userPrevRegister.email;
                            saveUser.id = user.uid;
                            saveUser.name = this.userPrevRegister.name;
                            saveUser.nifCif = this.userPrevRegister.nifCif;
                            saveUser.planes.push(this.userPrev.plan);
                            saveUser.telefono = this.userPrevRegister.telefono;
                            this._planes.find(saveUser.planes[0]).then(planDb => {
                                for(let i = 0; i < planDb.numProyects; i++){
                                    let pQr = new ProyectQr();
                                    pQr.name += ' ' + (i + 1);
                                    pQr.carpetas[0].name = 'Default 1';
                                    saveUser.codigosQr.push(pQr);
                                }
                                this._user.store(saveUser).then(_ => {
                                    this.userLoggend = saveUser;
                                    this.userPrev = null;
                                    this.userPrevRegister = null;
                                    this.loginEmitter.emit(null);
                                });
                            });
                        });
                    } else {
                        console.log('auth no user');
                        this.isLoggedIn = false;
                        this.logoutEmitter.emit({finishSignUp: (window.location.href.indexOf('finishSignUp') != -1), baned: true});
                        this.logout();
                    }
                });
            } else {
                this.isLoggedIn = false;
                this.logoutEmitter.emit({finishSignUp: (window.location.href.indexOf('finishSignUp') != -1), baned: false});
            }
        });
    }

    checkLinkEmail(url: string, email: string) {
        var promise = new Promise((resolve, reject) => {
            if (this.afAuth.auth.isSignInWithEmailLink(url)) {
                this.afAuth.auth.signInWithEmailLink(email, url).then((result) => {
                    resolve(result.user);

                }).catch(error => reject(error));
            } else {
                reject('url no permitida o caducada, pida otra url al administrador');
            }
        });

        return promise;
    }

    logout() {
        this.afAuth.auth.signOut();
        this.redirectUrl = null;
        this.logoutEmitter.emit({finishSignUp: false, baned: false});
    }

    registerNewUser(user: NewUserFinish): Promise<any> {
        var promise = new Promise((resolve, reject) => {
            this.afAuth.auth.createUserWithEmailAndPassword(user.email, user.pass).then(() => {
                this.afAuth.auth.currentUser.updateProfile({
                    displayName: user.name,
                    photoURL: '',
                }).then(() => {
                    resolve(true);
                });
            });
        });
        return promise;
    }

    saveCredentialsStorage(user: UserLogin) {
        localStorage.setItem('intrapro-user', this._utils.Base64encode(JSON.stringify(user)));
        this.authUserCredentials = user;
        console.log(localStorage.getItem('intrapro-user'), this.authUserCredentials);
    }

    sendSignInLinkToEmail(email: string, id: string) {
        var promise = new Promise((resolve, reject) => {
            firebase.auth().sendSignInLinkToEmail(email, { url: environment.finishSignUpUrl + id, handleCodeInApp: true }).then(() => {
                localStorage.setItem('emailForSignIn', email);
                resolve('enviado email ' + email);
            }).catch(function (error) {
                // Some error occurred, you can inspect the code: error.code
                console.log('error enviando el email', error);
                reject(error);
            });
        });

        return promise;
    }

    signInWithEmailAndPass(user: UserLogin): Promise<{}> {
        var promise = new Promise((resolve, reject) => {
            this.afAuth.auth.signInWithEmailAndPassword(user.email, user.pass).then(() => {
                // firebase.database().ref('/usuarios').child(this.afAuth.auth.currentUser.uid).on('value', snap => {
                resolve(true);
                // });
            }).catch((err) => {
                reject(err);
            });
        });

        return promise;
    }
}

export class UserLogin {
    email: string;
    pass: string;
    constructor(user?: { email: string, pass: string }) {
        this.email = user ? user.email : '';
        this.pass = user ? user.pass : '';
    }
}

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private _auth: AuthProvider, private afAuth: AngularFireAuth, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let url: string = state.url;
        return this.checkLogin(url);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    checkLogin(url: string): boolean {
        if (this._auth.isLoggedIn) { return true; }

        // Store the attempted URL for redirecting
        this._auth.redirectUrl = url;

        // Navigate to the login page with extras
        this.router.navigate(['/login']);
        return false;
    }

}


// WEBPACK FOOTER //
// ./src/app/providers/auth.ts